const useWakeWord = () => ({
  start: () => undefined,
  stop: () => undefined,
  enableAfterTTS: () => undefined,
});

export const startWakeWord = () => undefined;
export const stopWakeWord = () => undefined;

export const usePocketSphinxWakeWord = useWakeWord;

export default useWakeWord
